<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">สมัครสมาชิก</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <Form @submit="onRegister" :validation-schema="schema">
                    <vee-input
                      name="username"
                      type="text"
                      placeholder="Username"
                      label="ชื่อผู้ใช้"
                    />
                    <vee-input
                      name="password"
                      type="password"
                      placeholder="Password"
                      label="รหัสผ่าน"
                    />
                    <vee-input
                      name="confirm_password"
                      type="password"
                      placeholder="Confirm Password"
                      label="กรอกรหัสผ่านอีกครั้ง"
                    />
                    <vee-input
                      name="name"
                      type="text"
                      placeholder="Name"
                      label="ชื่อ"
                    />
                    <vee-input
                      name="surname"
                      type="text"
                      placeholder="Surname"
                      label="นามสกุล"
                    />
                    <vee-input
                      name="phonenumber"
                      type="tel"
                      placeholder="Phone Number"
                      label="เบอร์โทรศัพท์"
                    />
                    <vee-input
                      name="email"
                      type="email"
                      placeholder="Email"
                      label="อีเมล"
                    />
                    <div class="category form-category">* Required fields</div>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <n-button native-type="submit" type="primary"
                        >Register</n-button
                      >
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <div class="card-header">
                    <h4 class="card-title text-center">
                      หรือเชื่อมต่อด้วยช่องทางอื่น ๆ
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <div>
                          <n-button
                            class="btn-line"
                            size="lg"
                            style="width: 257px"
                            @click="loginWithLine"
                          >
                            <i class="fab fa-line fa-lg"></i> ล็อกอินด้วย Line
                          </n-button>
                        </div>
                        <div>
                          <n-button
                            class="btn-facebook"
                            size="lg"
                            style="width: 257px"
                            @click="loginWithFacebook"
                          >
                            <i class="fab fa-facebook fa-lg"></i> ล็อกอินด้วย
                            Facebook
                          </n-button>
                        </div>

                        <div>
                          <n-button
                            class="btn-google"
                            size="lg"
                            style="width: 257px"
                            @click="loginWithGoogle"
                          >
                            <i class="fab fa-google fa-lg"></i> ล็อกอินด้วย
                            Google
                          </n-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VeeInput, Checkbox } from "@/components";
import { Form } from "vee-validate";
import * as Yup from "yup";
import firebase from "firebase";
import "firebase/functions";
import * as userservice from "../../services/user";
import * as configuration from "../../middleware/configuration";
import { message } from "ant-design-vue";

export default {
  components: {
    Checkbox,
    VeeInput,
    Form,
  },
  methods: {
    async onRegister(values) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(values.email, values.password)
        .then(async (user) => {
          if (user) {
            let currentuser = await configuration.getCurrentUser();
            currentuser
              .updateProfile({
                displayName: `${values.name} ${values.surname}`,
                phoneNumber: values.phonenumber,
              })
              .then(async () => {
                var data = {
                  Uid: user.user.uid,
                  Username: values.username,
                  Providers: user.additionalUserInfo.providerId,
                  Name: values.name,
                  Surname: values.surname,
                  Tel: values.phonenumber,
                  Email: values.email,
                };
                await this.onSubmit(data);
                firebase.auth().currentUser.getIdToken(true);
              });

            user.sendEmailVerification().then(() => {
              console.log("send confirmation email");
            });
          }
        });
    },
    async onSubmit(values) {
      var data = {
        Uid: values.Uid,
        Username: values.Username,
        Providers: values.Providers,
        Name: values.Name,
        Surname: values.Surname,
        Tel: values.PhoneNumber,
        Email: values.Email,
      };

      try {
        let res = await userservice.register(data);
        const datares = JSON.stringify(res.data);
        localStorage.setItem("userinfo", datares);
      } catch (error) {
        message.error("ไม่สามารถสมัครสาชิกได้ กรุณาลองอีกครั้ง");
      } finally {
        if (localStorage.getItem("AcceptTerm")) {
          this.$router.push("/payment");
        } else {
          this.$router.push("/game");
        }
      }
    },
    async loginWithGoogle(e) {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          async (user) => {
            var data = {
              Uid: user.user.uid,
              Username: null,
              Providers: user.additionalUserInfo.providerId,
              Name: user.additionalUserInfo.profile.given_name,
              Surname: user.additionalUserInfo.profile.family_name,
              PhoneNumber: user.user.phoneNumber,
              Email: user.user.email,
            };
            await this.onSubmit(data);
          },
          (err) => {
            alert(err.message);
          }
        );
    },
    async loginWithFacebook(e) {
      var provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(
          async (user) => {
            var data = {
              Uid: user.user.uid,
              Username: null,
              Providers: user.additionalUserInfo.providerId,
              Name: user.additionalUserInfo.profile.first_name,
              Surname: user.additionalUserInfo.profile.last_name,
              PhoneNumber: user.user.phoneNumber,
              Email: user.additionalUserInfo.profile.email,
            };
            await this.onSubmit(data);
          },
          (err) => {
            alert(err.message);
          }
        );
    },
    loginWithLine() {
      window.location.href =
        "https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1656018206&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Fauth%2Fline&state=12345abcde&scope=profile%20openid%20email&nonce=09876xyz";
    },
  },
  beforeMount() {
    let currentUser = firebase.auth().currentUser;
    if (currentUser) {
      uid = currentUser.uid;
      this.$router.push("/game");
    } else {
      let authListenerUnsuscribe = firebase
        .auth()
        .onAuthStateChanged((user) => {
          if (user) {
            uid = user.uid;
            authListenerUnsuscribe();
            this.$router.push("/game");
          }
        });
    }
  },
  setup() {
    const phoneRegExp =
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const schema = Yup.object().shape({
      username: Yup.string().required().label("The Username"),
      password: Yup.string().min(8).required().label("The Password"),
      confirm_password: Yup.string()
        .required()
        .oneOf([Yup.ref("password")], "Passwords do not match"),
      name: Yup.string().required().label("The Name"),
      surname: Yup.string().required().label("The Surname"),
      phonenumber: Yup.string()
        .matches(phoneRegExp, "Phone number is not valid")
        .required()
        .label("The Phone number"),
      email: Yup.string().email().required().label("The Email"),
    });
    return {
      schema,
    };
  },
};
</script>

<style>
</style>